import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef, useMemo, useRef, useCallback, useLayoutEffect, useImperativeHandle } from "react";
import { Typography, Tooltip } from "@mui/material";
import "lottie-react";
import { Avatar } from "../../../components/avatar/avatar.js";
import "../../../components/avatar-group/avatar-group.styles.js";
import "../../../themes/shadows/shadows.js";
import "../../../themes/typography/typography.js";
import "../../../components/date-pickers/pickers-action-bar/pickers-action-bar.js";
import "../../../components/date-pickers/date-picker/theme/index.js";
import "../../../components/dialog/dialog.js";
import "../../../components/icons/all/all.js";
import "../../../components/label/label.styles.js";
import "../../../components/menu-item/menu-item.js";
import "../../../components/slider/slider.styles.js";
import "@mui/material/styles";
import "../../../components/snackbar/snackbar.styles.js";
import "../../../components/styled-text-field/styled-text-field.styles.js";
import "../../../components/swipeable-drawer/swipeable-drawer.js";
import "../../../components/translations/utils.js";
import "../../../components/time-select/time-select.styles.js";
import "../../../components/time-interval-select/time-interval-select.styles.js";
import { startOfWeek, addDays, format, differenceInDays, isThisWeek, isToday, add } from "date-fns";
import { DATE_FORMAT, MAX_STACKED_EXTENDED_ITEMS_TO_SHOW, MAX_STACKED_ITEMS_TO_SHOW } from "./appointment-schedule.constants.js";
import { withAppointmentScheduleProviders } from "./appointment-schedule.providers.js";
import { Wrapper, InnerWrapper, ScheduleWrapper, ScheduleHeaderWrapper, ScheduleDayWrapper, ScheduleDayHeader, ScheduleEmployeesWrapper, ScheduleEmployeeHeader, AvatarWrapper, EmployeeName, EmployeeWorkingTimes, ScheduleContentWrapper } from "./appointment-schedule.styles.js";
import { EmployeeRole, EmployeeLevel } from "./appointment-schedule.types.js";
import { CustomScrollbar } from "./components/custom-scrollbar/custom-scrollbar.js";
import { EmployeeColumn } from "./components/employee-column/employee-column.js";
import { TimeColumn } from "./components/time-column/time-column.js";
import { getWorkRange } from "./helpers/getWorkRange.js";
import "lodash";
import { getLocale, getNameInitials } from "./helpers/common.js";
import { getMinHeaderWidth } from "./helpers/getHeaderMinWidth.js";
import { useDragContainer } from "./hooks/useDragContainer.js";
import { useElementSize } from "./hooks/useElementSize.js";
import { useSaveAppointment } from "./hooks/useSaveAppointment.js";
import { useStickyElement } from "./hooks/useStickyElement.js";
import "./providers/axios-provider.js";
import "./providers/time-indicator-provider.js";
import { useAppointmentsProvider } from "./providers/appointments-provider.js";
import { useWorkingTimesProvider } from "./providers/working-times-provider.js";
import { DragAndDropProvider } from "./providers/drag-and-drop-provider.js";
import "./components/appointments-modal/appointments-modal.js";
import { useAppointmentDetailsModalProvider } from "./providers/appointment-details-modal-provider.js";
import "./providers/appointments-modal-provider.context.js";
import { useAppointmentsModalProvider } from "./providers/appointments-modal-provider.hooks.js";
import { useBlockerModalProvider } from "./providers/blocker-modal-provider.js";
import "@mui/material/Avatar/index.js";
import "../../../components/avatar/avatar.styles.js";
import "../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "@mui/system";
import "@mui/material/Button/index.js";
import "@mui/x-date-pickers/internals/index.js";
import "../../../constants/create-theme/create-theme.js";
import "../../../constants/colors/palette.js";
import "../../../themes/button/button.js";
import "../../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../../themes/button/styles/external/filled.styles.js";
import "../../../themes/button/styles/internal/bordered.styles.js";
import "../../../themes/button/styles/internal/borderless.styles.js";
import "../../../themes/button/styles/internal/filled.styles.js";
import "../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../components/date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "../../../themes/date-calendar/date-calendar.js";
import "../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../themes/day-calendar/day-calendar.js";
import "../../../themes/filled-input/filled-input.js";
import "../../../themes/form-helper-text/form-helper-text.js";
import "../../../themes/form-label/form-label.js";
import "../../../themes/month-calendar/month-calendar.js";
import "../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../themes/pickers-day/pickers-day.js";
import "@mui/x-date-pickers";
import "../../../themes/pickers-month/pickers-month.js";
import "../../../themes/pickers-popper/pickers-popper.js";
import "../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../themes/pickers-year/pickers-year.js";
import "../../../themes/year-calendar/year-calendar.js";
import "@mui/icons-material/Close.js";
import "../../../themes/alert/alert.js";
import "../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../themes/dialog/dialog.js";
import "../../../themes/external-theme/external-theme.js";
import "../../../constants/breakpoints/breakpoints.js";
import "../../../themes/checkbox/checkbox.js";
import "../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../themes/form-control-label/form-control-label.js";
import "../../../themes/radio/radio.js";
import "../../../themes/switch/switch.js";
import "../../../themes/popover/popover.js";
import "../../../themes/tooltip/tooltip.js";
import "../../../components/dialog/dialog.constants.js";
import "../../../components/dialog/dialog.styles.js";
import "@emotion/react";
import "../../../components/dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../../../components/icons/CalendarEventIcon/CalendarEventIcon.js";
import "../../../components/icons/MainIcon/MainIcon.js";
import "../../../components/icons/CalendarIcon/CalendarIcon.js";
import "../../../components/icons/CardIcon/CardIcon.js";
import "../../../components/icons/ChecklistIcon/ChecklistIcon.js";
import "../../../components/icons/ClockIcon/ClockIcon.js";
import "../../../components/icons/CloseIcon/CloseIcon.js";
import "../../../components/icons/EditIcon/EditIcon.js";
import "../../../components/icons/EmptyCalendar/EmptyCalendar.js";
import "../../../components/icons/EventNote/EventNote.js";
import "../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../components/icons/ListIcon/ListIcon.js";
import "../../../components/icons/MessageBubble/MessageBubble.js";
import "../../../components/icons/PhoneIcon/PhoneIcon.js";
import "../../../components/icons/PinIcon/PinIcon.js";
import "../../../components/icons/SearchIcon/SearchIcon.js";
import "../../../components/icons/TherapyNotesIcon/TherapyNotesIcon.js";
import "../../../components/icons/TimerIcon/TimerIcon.js";
import "../../../components/icons/TreatmentChairIcon/TreatmentIcon.js";
import "../../../components/icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "../../../components/icons/WarningIcon/WarningIcon.js";
import "@mui/material/MenuItem/index.js";
import "../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../components/menu-item/menu-item.styles.js";
import "@mui/material/Snackbar/index.js";
import "../../../components/snackbar/snackbar.types.js";
import "../../../components/text-field/text-field.js";
import "@mui/material/TextField/index.js";
import "../../../components/text-field/text-field.styles.js";
import "../../../components/swipeable-drawer/swipeable-drawer.styles.js";
import "react-i18next";
import "../../../type/Translations.js";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "@mui/icons-material/Timer.js";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
import "@mui/material/Box/index.js";
import "@tanstack/react-query";
import "@dnd-kit/core";
import "./providers/appointments-modal-provider.js";
import "@mui/material/ClickAwayListener/index.js";
import "@mui/material/Popover/index.js";
import "./helpers/groupBy.js";
import "../../../utils/time/time.js";
import "date-fns/locale";
import "fast-memoize";
import "date-fns/getHours";
import "date-fns/isThisWeek";
import "date-fns/isToday";
import "date-fns/isValid";
import "./components/appointment/appointment.js";
import "@mui/icons-material/Comment.js";
import "../../../components/styled-tooltip/styled-tooltip.js";
import "../../../constants/date/date.js";
import "../../../constants/time/time.js";
import "../../components/appointments-picker/appointments-picker.styles.js";
import "@mui/icons-material/ArrowBackIos.js";
import "@mui/icons-material/ExpandMore.js";
import "@mui/material/Card/index.js";
import "@mui/material/CardContent/index.js";
import "clsx";
import "../../components/appointments-picker/components/AvailableSlot/AvailableSlot.styles.js";
import "../../components/appointments-picker/components/CurrentPeriod/CurrentPeriod.styles.js";
import "../../components/appointments-picker/components/NextPeriod/NextPeriod.styles.js";
import "@mui/icons-material/KeyboardArrowRight.js";
import "../../components/appointments-picker/components/PrevPeriod/PrevPeriod.styles.js";
import "@mui/icons-material/KeyboardArrowLeft.js";
import "../../components/appointments-picker/components/QuickFilter/QuickFilter.styles.js";
import "../../components/appointments-picker/components/TimeFrames/TimeFrames.styles.js";
import "../../components/appointments-picker/components/UnavailableSlot/UnavailableSlot.styles.js";
import "../../components/appointments-picker/components/WorkingDay/WorkingDay.styles.js";
import "../../components/chemistry-info/chemistry-info.styles.js";
import "../../components/clinic-location-details/clinic-location-details.styles.js";
import "../../components/clinic-location-details/Day/styles.js";
import "../../components/clinic-location-details/Map/Map.js";
import "google-map-react";
import "../../components/floating-button/floating-button-container/styles.js";
import "../../components/floating-button/floating-button.styles.js";
import "../../components/news-section/news-section.styles.js";
import "../../components/obfuscated-text/obfuscated-text.js";
import "../../components/obfuscated-text/obfuscated-text.styles.js";
import "../../components/pain-details-form/pain-details-form.styles.js";
import "../../components/pain-details-form/constants/constants.js";
import "../../components/pain-details-form/types.js";
import "react-slick";
import "../../components/task-form/components/Avatar/Avatar.styles.js";
import "../../components/task-form/assets/icons/Avatar.js";
import "../../components/task-form/assets/icons/Logo.js";
import "../../components/task-form/components/Comments/Comments.styles.js";
import "../../components/task-form/assets/icons/Comment.js";
import "lodash/debounce.js";
import "../../components/task-form/components/DatePicker/DatePicker.styles.js";
import "../../components/task-form/components/EmployeeMenuItem/EmployeeMenuItem.styles.js";
import "../../components/task-form/components/EmployeesDropdown/EmployeesDropdown.styles.js";
import "../../components/task-form/components/PatientAutocomplete/PatientAutocomplete.styles.js";
import "@hookform/resolvers/yup";
import "../../components/task-form/task-form.entities.js";
import "yup";
import "../../components/task-form/task-form.helpers.js";
import "../../components/task-form/task-form.types.js";
import "../../components/task-form/task-form.styles.js";
import "../../components/task-form/assets/icons/Important.js";
import "../../components/task-form/assets/icons/TaskCategory.js";
import "../../components/task-form/assets/icons/TaskDescription.js";
import "../../components/task-form/assets/icons/TaskName.js";
import "../../components/task-form/theme/index.js";
import "../../components/task-form/theme/overrides/Button.js";
import "../../components/task-form/theme/overrides/PickersLayout.js";
import "../../components/task-form/theme/overrides/Menu.js";
import "../../components/task-form/theme/overrides/Autocomplete.js";
import "../../components/team-section/constants/constants.js";
import "../../components/team-section/components/Rating/styles.js";
import "../../components/team-section/team-section.styles.js";
import "../../components/testimonials-section/constants.js";
import "../../components/testimonials-section/PractitionerTestimonialCard/styles.js";
import "../../components/testimonials-video-section/testimonials-video-section.styles.js";
import "../../components/employee-select/employee-select.js";
import "../../../themes/icon-button/icon-button.js";
import "../../../themes/tabs/tabs.js";
import "../../components/employee-select/components/employee-search-input/employee-search-input.js";
import "../../components/employee-select/components/employee-search-input/employee-search-input.styles.js";
import "../../components/employee-select/assets/icons/Search.js";
import "../../components/employee-select/employee-select.styles.js";
import "../../components/employee-select/assets/icons/Arrow.js";
import "../../components/employee-select/assets/icons/Employees.js";
import "../../components/ana/utils/shared/Checkbox.js";
import "../../components/ana/utils/shared/FormControlLabel.js";
import "../../components/ana/components/translate/translate.js";
import "../../components/ana/components/checklist-input/checklist-input.styles.js";
import "react-dom";
import "../../components/ana/components/address-field/address-field.js";
import "formik";
import "../../components/ana/utils/helpers/getHasError.js";
import "../../components/ana/utils/hooks/useAddressSuggestions.js";
import "use-debounce";
import "../../components/ana/utils/helpers/googlePlaces.js";
import "../../components/ana/utils/helpers/places.js";
import "../../components/ana/utils/hooks/useFormHelpers.js";
import "../../components/ana/utils/hooks/useSubmitCount.js";
import "../../components/ana/utils/shared/TextField.js";
import "../../components/ana/utils/shared/TextFieldLabel.js";
import "../../components/ana/utils/yup/main.js";
import "../../components/ana/utils/fields/personalInformation.js";
import "../../../type/Appointment.js";
import "../../components/ana/components/masked-date-input/masked-date-input.js";
import "react-text-mask";
import "../../components/ana/utils/entities/Form.js";
import "../../components/ana-toolbox/ana-toolbox.js";
import "date-fns/fp/format";
import "date-fns/parse";
import "../../components/ana/utils/helpers/toBoolean.js";
import "../../components/ana/utils/helpers/createFields.js";
import "../../components/ana/utils/helpers/resetFields.js";
import "../../components/ana/utils/yup/yup.js";
import "../../../utils/pipe.js";
import "date-fns/fp";
import "libphonenumber-js/max";
import "libphonenumber-js/mobile";
import "../../components/ana/utils/helpers/predicates.js";
import "../../components/ana/utils/yup/emailValidation.js";
import "../../components/ana/utils/fields/contactDetails.js";
import "../../components/ana/utils/helpers/featureFlags.js";
import "../../components/ana/utils/helpers/getAgeFromBirthday.js";
import "../../components/ana/utils/yup/buildValidationSchema.js";
import "../../components/ana/utils/fields/miscellaneous.js";
import "../../components/ana/utils/fields/insurance.js";
import "../../components/ana/utils/fields/allergiesAndMedications.js";
import "../../../type/Disease.js";
import "../../components/ana/utils/config/medicaments.js";
import "../../components/ana/utils/fields/wishesAndExpectations.js";
import "../../components/ana/utils/fields/consents.js";
import "../../components/ana/utils/fields/profileInterest.js";
import "../../components/ana/components/field-helper-text/field-helper-text.js";
import "../../components/ana/components/checkbox-field/checkbox-field.styles.js";
import "../../components/ana/components/date-picker-field/date-picker-field.js";
import "@mui/x-date-pickers/StaticDatePicker/index.js";
import "date-fns/fp/formatWithOptions";
import "date-fns/locale/de";
import "date-fns/locale/en-US";
import "../../components/ana/utils/helpers/date.js";
import "date-fns/fp/startOfMonth";
import "date-fns/fp/subYears";
import "../../components/ana/components/date-picker-field/date-picker-field.styles.js";
import "../../components/ana/components/phone-field/phone-field.js";
import "react-window";
import "@mui/icons-material/ArrowDropDown.js";
import "libphonenumber-js";
import "../../components/ana/utils/helpers/phoneMetadata.js";
import "../../components/ana/components/text-input/text-input.js";
import "../../components/ana/components/text-input/text-input.styles.js";
import "../../components/ana/components/phone-field/phone-field.styles.js";
import "../../components/ana/components/radio-group/radio-group.js";
import "use-deep-compare";
import "../../components/ana/utils/shared/Radio.js";
import "../../components/ana/utils/shared/RadioFormControl.js";
import "../../components/ana/utils/shared/RadioFormControlLabel.js";
import "../../components/ana/utils/shared/RadioFormLabel.js";
import "../../components/ana/utils/shared/RadioGroup.js";
import "../../components/ana/components/select-input/select-input.styles.js";
import "../../components/ana/components/toggle-field/toggle-field.js";
import "../../components/ana/utils/shared/ToggleContainer.js";
import "../../components/ana/utils/shared/ToggleFormControlLabel.js";
import "../../components/ana/utils/hooks/useFormValue.js";
import "../../components/ana/components/form-layout/form-layout.styles.js";
import "../../components/ana/utils/shared/Button.js";
import "../../components/ana/components/submit-button/submit-button.styles.js";
import "../../components/ana/components/toggle-multi-checkbox/toggle-multi-checkbox.styles.js";
import "../../components/ana/utils/config/diseases.js";
import "../../components/ana/components/insurance-field/insurance-field.js";
import "fuse.js";
import "../../components/ana/components/insurance-field/insurance-field-helpers.js";
import "../../components/ana/components/insurance-field/Insurance-field.styles.js";
import "../../components/ana/utils/shared/SectionTitle.js";
import "../../components/ana/components/callout/Callout.styles.js";
import "../../components/ana/utils/types/contentful.js";
import "../../components/ana/utils/shared/AddressLayoutItem.js";
import "../../components/ana/utils/helpers/getIsRequired.js";
import "../../components/ana/forms/miscellaneous/miscellaneous.js";
import "../../components/ana/components/form-layout/form-layout.js";
import "../../components/ana/utils/helpers/createField.js";
import "../../components/ana/components/checkbox-field/checkbox-field.js";
import "../../components/ana/components/select-field/select-field.js";
import "../../components/ana/components/select-input/select-input.js";
import "../../components/ana/components/text-field/text-field.js";
import "../../components/ana/components/submit-button/submit-button.js";
import "../../../components/loader/loader.js";
import "../../../components/loader/data.js";
import "../../../components/animation/animation.js";
import "../../../components/loader/loader.styles.js";
import "../../components/ana/utils/helpers/getFormInitialErrors.js";
import "../../components/ana/utils/config/wishes.js";
import "../../components/ana/forms/preconditions/preconditions.js";
import "../../components/ana/components/disease-group-field/disease-group-field.js";
import "../../components/ana/utils/helpers/DiseaseType.js";
import "../../components/ana/components/disease-field/disease-field.js";
import "../../components/ana/components/tag/tag.js";
import "../../components/ana/components/tag/tag.styles.js";
import "@mui/icons-material/Cancel.js";
import "../../components/ana/components/disease-field/disease-field.styles.js";
import "@mui/styles";
import "../../components/ana/components/disease-group-field/disease-group-field.helpers.js";
import "../../components/ana/components/disease-group-field/disease-group-field.styles.js";
import "../../components/ana/utils/hooks/usePreConditionsToggle.js";
import "../../components/ana/utils/helpers/scrollToElementIfNotVisible.js";
import "../../components/ana/utils/helpers/isInViewport.js";
import "../../components/ana/forms/preconditions/preconditions.styles.js";
import "../../components/ana/components/legal-representative-dialog/legal-representative-dialog.styles.js";
import "../../components/ana/utils/shared/Modal.js";
import "../../components/ana/utils/helpers/i18n.js";
import "../../components/ana/components/ana-dialog/ana-dialog.styles.js";
import "../../components/ana/utils/config/wishesAndExpectations.js";
import "../../../hooks/useFilterEmployees/useFilterEmployees.js";
import "../../../type/Employee.js";
import "../../../utils/array.js";
import "../../../utils/employee/getUniqueByRoles.js";
import "lodash/reverse.js";
import "lodash/uniqBy.js";
import "../../components/website/common/button/styles.js";
import "../../components/website/jobs/job-description-section/styles.js";
import "../../components/website/jobs/job-details-hero-section/styles.js";
import "../../components/website/common/button/button.js";
import "../../../hooks/useResponsive.js";
import "../../components/smileview-section/hooks/useWindowSize.js";
import "../../components/website/directions-section/styles.js";
import "react-headroom";
import "../../components/page-header/context/header-context.js";
import "../../components/page-header/components/header-skip/styles.js";
import "../../../components/expandable/expandable-dropdown/expandable-dropdown.styles.js";
import "../../../components/expandable/expandable-group/expandable-group-context.js";
import "../../components/page-header/page-header-mobile/page-header-mobile-content/styles.js";
import "query-string";
import "../../components/authentication/components/CredentialsProvider.js";
import "../../components/authentication/config.js";
import "../../components/authentication/helpers/time.js";
import "../../components/authentication/hooks/useStickyState.js";
import "../../components/authentication/services/api.js";
import "axios";
import "../../components/authentication/helpers/credentials.js";
import "../../components/authentication/helpers/headers.js";
import "../../components/authentication/components/RouterProvider.js";
import "../../components/authentication/components/SecurityConfigProvider.js";
import "../../components/authentication/services/i18n.js";
import "../../components/authentication/components/auth-container/auth-container.styles.js";
import "@emotion/styled";
import "../../components/authentication/components/login-page/login-page.styles.js";
import "../../components/authentication/components/TrustedDeviceProvider.js";
import "../../components/authentication/components/HistoryProvider.js";
import "./hooks/useAppointmentResize.js";
import "./components/appointment/appointment.helpers.js";
import "./components/appointment/appointment.styles.js";
import "./helpers/hexToRgb.js";
import "./components/blocker-modal/blocker-modal.js";
import "react-hook-form";
import "@mui/icons-material/CheckBox.js";
import "@mui/icons-material/CheckBoxOutlineBlank.js";
import "@mui/material/Checkbox/index.js";
import "../../../components/date-pickers/date-picker/date-picker.js";
import "@mui/x-date-pickers/AdapterDateFns/index.js";
import "@mui/x-date-pickers/DatePicker/index.js";
import "../../../components/time-interval-select/time-interval-select.js";
import "../../../components/time-select/time-select.js";
import "@mui/material/InputAdornment/index.js";
import "@mui/material/Typography/index.js";
import "../../../components/time-select/time-select.hepers.js";
import "../../../components/time-interval-select/time-interval-select.helpers.js";
import "../appointment-details/assets/icons/Date.js";
import "../appointment-details/assets/icons/Title.js";
import "../appointment-details/components/employee-autocomplete/employee-autocomplete.js";
import "@mui/icons-material";
import "../appointment-details/assets/icons/Employee.js";
import "../appointment-details/helpers/common.js";
import "../appointment-details/appointment-details.types.js";
import "../appointment-details/hooks/useEmployeeSearch.js";
import "../appointment-details/providers/axios-provider.js";
import "../appointment-details/components/appointment-form/appointment-form.constants.js";
import "../appointment-details/components/appointment-form/appointment-form.helpers.js";
import "../appointment-details/helpers/appointment.js";
import "../appointment-details/components/employee-autocomplete/employee-autocomplete.skeleton.js";
import "../appointment-details/components/employee-autocomplete/employee-autocomplete.styles.js";
import "../../../utils/string/getNameInitials.js";
import "./hooks/useBlockerForm.js";
import "date-fns/startOfToday";
import "./hooks/useSaveBlocker.js";
import "./components/blocker-deletion-modal/blocker-deletion-modal.js";
import "./hooks/useDeleteBlocker.js";
import "./components/blocker-deletion-modal/blocker-deletion-modal.styles.js";
import "./helpers/getViewTimePeriod.js";
import "./helpers/getEmptyCalendarSlots.js";
import "./helpers/fillEmptyDays.js";
import "./hooks/useWorkingTimes.js";
import "./components/blocker-modal/blocker-modal.styles.js";
import "@mui/material/FormControlLabel/index.js";
import "./components/employee-column/employee-column.helpers.js";
import "./components/employee-column/helpers/splitSlotsToIntervals.js";
import "./components/time-column/time-column.helpers.js";
import "./components/time-column/time-column.styles.js";
import "./components/appointments-modal/appointments-modal.helpers.js";
import "./components/appointments-modal/appointments-modal.styles.js";
import "../appointment-details/appointment-details.js";
import "../appointment-details/appointment-details.providers.js";
import "../appointment-details/providers/appointments-provider.js";
import "../appointment-details/hooks/useAppointments.js";
import "../appointment-details/appointment-details.styles.js";
import "../appointment-details/components/appointment-cancellation-dialog/appointment-cancellation-dialog.js";
import "../appointment-details/assets/icons/CancellationReason.js";
import "../appointment-details/assets/icons/Comment.js";
import "../appointment-details/hooks/useCancelAppointment.js";
import "../appointment-details/components/appointment-cancellation-dialog/appointment-cancellation-dialog.styles.js";
import "../appointment-details/components/appointment-deletion-dialog/appointment-deletion-dialog.js";
import "../appointment-details/hooks/useDeleteAppointment.js";
import "../appointment-details/components/appointment-deletion-dialog/appointment-deletion-dialog.styles.js";
import "../appointment-details/components/appointment-form/appointment-form.js";
import "../appointment-details/assets/icons/Duration.js";
import "../appointment-details/hooks/useDoesAppointmentExist.js";
import "../appointment-details/hooks/useTreatments.js";
import "../appointment-details/components/appointment-date-select/appointment-date-select.js";
import "../../components/appointments-picker/appointments-picker.js";
import "date-fns-tz";
import "swiper/react";
import "../../components/appointments-picker/appointments-picker.helpers.js";
import "../../components/appointments-picker/components/AvailableSlot/AvailableSlot.js";
import "../../components/appointments-picker/constants/dataTestIds.js";
import "../../components/appointments-picker/components/CurrentPeriod/CurrentPeriod.js";
import "../../components/appointments-picker/components/NextPeriod/NextPeriod.js";
import "../../components/appointments-picker/components/PrevPeriod/PrevPeriod.js";
import "../../components/appointments-picker/components/QuickFilter/QuickFilter.js";
import "../../components/appointments-picker/components/TimeFrames/TimeFrames.js";
import "@mui/icons-material/Check.js";
import "../../components/appointments-picker/components/UnavailableSlot/UnavailableSlot.js";
import "../../components/appointments-picker/components/WorkingDay/WorkingDay.js";
import "../appointment-details/hooks/useDebounce.js";
import "../appointment-details/hooks/useTimeSlots.js";
import "../appointment-details/components/appointment-date-select/appointment-date-select.styles.js";
import "../appointment-details/components/employee-select/employee-select.js";
import "../../../components/chip/chip.js";
import "@mui/material/Chip/index.js";
import "../../../components/chip/chip.styles.js";
import "../appointment-details/assets/icons/Cross.js";
import "../appointment-details/components/employee-select/employee-select.skeleton.js";
import "../appointment-details/components/employee-select/employee-select.styles.js";
import "../appointment-details/components/new-patient-form/new-patient-form.js";
import "../appointment-details/assets/icons/Birthday.js";
import "../appointment-details/assets/icons/Insurance.js";
import "../appointment-details/assets/icons/Mail.js";
import "../appointment-details/assets/icons/Patient.js";
import "../appointment-details/assets/icons/Phone.js";
import "../appointment-details/components/new-patient-form/new-patient-form.styles.js";
import "../appointment-details/components/patient-autocomplete/patient-autocomplete.js";
import "../appointment-details/hooks/usePatientSearch.js";
import "../appointment-details/components/patient-autocomplete/patient-autocomplete.skeleton.js";
import "../appointment-details/components/patient-autocomplete/patient-autocomplete.styles.js";
import "../appointment-details/components/treatment-autocomplete/treatment-autocomplete.js";
import "../appointment-details/assets/icons/Treatment.js";
import "../appointment-details/components/treatment-autocomplete/treatment-autocomplete.helpers.js";
import "../appointment-details/components/treatment-autocomplete/treatment-autocomplete.skeleton.js";
import "../appointment-details/components/treatment-autocomplete/treatment-autocomplete.styles.js";
import "../appointment-details/components/appointment-form/appointment-form.styles.js";
import "../appointment-details/components/appointment-info/appointment-info.js";
import "../appointment-details/assets/icons/CancellationType.js";
import "../appointment-details/assets/icons/CancellationUser.js";
import "../appointment-details/assets/icons/CreatedBy.js";
import "../appointment-details/assets/icons/WarningIcon.js";
import "../appointment-details/components/appointment-info/appointment-info.skeleton.js";
import "../appointment-details/components/appointment-info/appointment-info.styles.js";
import "../../../components/icon/icon.js";
import "../appointment-details/helpers/getInitialPosition.js";
import "../appointment-details/helpers/getButtonsLabels.js";
import "../appointment-details/hooks/useAppointment.js";
import "../appointment-details/hooks/useAppointmentForm.js";
import "../appointment-details/hooks/useSaveAppointment.js";
import "./hooks/useAppointments.js";
import "./hooks/useServerSentEvent.js";
import "./components/custom-scrollbar/custom-scrollbar.styles.js";
import "./components/free-slots-group/free-slots.group.js";
import "./helpers/displayMinutes.js";
import "./components/free-slots-group/free-slots.group.styles.js";
import "@mui/icons-material/Block.js";
import "./assets/icons/Add.js";
import "./components/employee-column/employee-column.styles.js";
const AppointmentScheduleComponent = forwardRef(
  ({
    view = "day",
    date = /* @__PURE__ */ new Date(),
    showWeekend = false,
    limitEmployees = 5,
    employees = [],
    language,
    labels,
    clinicReferenceId,
    onDropError,
    onDropSuccess,
    showWorkingOnly = false,
    onPatientClick,
    isObfuscated
  }, ref) => {
    var _a;
    const { workingTimes, nonWorkingTimes, queryResult: woringTimesQueryResult } = useWorkingTimesProvider();
    const { data: appointments, queryResult: appointmentsQueryResult } = useAppointmentsProvider();
    const { toggleModal } = useAppointmentDetailsModalProvider();
    const { toggleModal: toggleAppointmentsModal } = useAppointmentsModalProvider();
    const { openModal: openBlockerModal } = useBlockerModalProvider();
    const locale = getLocale(language);
    const weekStart = useMemo(() => startOfWeek(date, { weekStartsOn: 1 }), [date]);
    const { mutateAsync: updateAppointment } = useSaveAppointment();
    const isFetching = !!(woringTimesQueryResult == null ? void 0 : woringTimesQueryResult.isFetching) || !!(appointmentsQueryResult == null ? void 0 : appointmentsQueryResult.isFetching);
    const datesToShow = useMemo(() => {
      if (view === "day")
        return [date];
      const numberOfDays = showWeekend ? 7 : 5;
      return Array.from({ length: numberOfDays }).map((_, index) => addDays(weekStart, index));
    }, [date, showWeekend, view, weekStart]);
    const filteredEmployees = useMemo(
      () => view === "week" ? employees.slice(0, limitEmployees) : employees,
      [employees, limitEmployees, view]
    );
    const employeesToShow = useMemo(() => {
      if (isFetching || !showWorkingOnly)
        return datesToShow.map(() => filteredEmployees);
      return datesToShow.map(
        (currentDate) => filteredEmployees.filter(({ referenceId }) => {
          var _a2, _b;
          const currentFormattedDate = format(currentDate, DATE_FORMAT);
          return !!((_b = (_a2 = workingTimes == null ? void 0 : workingTimes[currentFormattedDate]) == null ? void 0 : _a2[referenceId]) == null ? void 0 : _b.length);
        })
      );
    }, [filteredEmployees, datesToShow, isFetching, showWorkingOnly, workingTimes]);
    const sortedEmployeesToShow = useMemo(() => {
      return employeesToShow.map(
        (employeesList) => [...employeesList].sort((a, b) => {
          const [aPosition] = a.positions ?? [];
          const [bPosition] = b.positions ?? [];
          if ((aPosition == null ? void 0 : aPosition.role) !== (bPosition == null ? void 0 : bPosition.role)) {
            return (aPosition == null ? void 0 : aPosition.role) === EmployeeRole.DENTIST ? -1 : 1;
          }
          if ((aPosition == null ? void 0 : aPosition.role) === EmployeeRole.DENTIST) {
            return (aPosition == null ? void 0 : aPosition.level) === EmployeeLevel.CHIEF ? -1 : (bPosition == null ? void 0 : bPosition.level) === EmployeeLevel.CHIEF ? 1 : 0;
          }
          return 0;
        })
      );
    }, [employeesToShow]);
    const scheduleWrapperRef = useRef(null);
    const wrapperRef = useRef(null);
    const headerRef = useRef(null);
    const timelineRef = useRef(null);
    const columnRefs = useRef([]);
    const currentDayIndex = useMemo(() => differenceInDays(date, weekStart), [date, weekStart]);
    const scrollToCurrentDay = useCallback(() => {
      var _a2, _b;
      const currentDayColumn = columnRefs.current[currentDayIndex];
      if (isThisWeek(date) && currentDayColumn) {
        const left = currentDayColumn.offsetLeft - (((_a2 = scheduleWrapperRef == null ? void 0 : scheduleWrapperRef.current) == null ? void 0 : _a2.scrollLeft) ?? 0);
        (_b = scheduleWrapperRef.current) == null ? void 0 : _b.scrollBy({
          left,
          behavior: "smooth"
        });
      }
    }, [date, currentDayIndex, columnRefs.current[currentDayIndex]]);
    const handleAppointmentClick = (data, event) => {
      const target = event.currentTarget;
      toggleModal(target, data);
    };
    const handleAppointmentResize = (appointment, differenceInMinutes) => {
      const { end, name, patient, employeeReferenceId, ...rest } = appointment;
      const updatedEndTime = add(end, { minutes: differenceInMinutes });
      const data = {
        end: updatedEndTime,
        clinicReferenceId,
        title: name,
        patientReferenceId: patient == null ? void 0 : patient.referenceId,
        practitionerReferenceId: employeeReferenceId,
        ...rest
      };
      if (differenceInMinutes) {
        updateAppointment({
          data
        });
      }
    };
    useLayoutEffect(() => scrollToCurrentDay(), [view, date, scrollToCurrentDay]);
    useStickyElement(wrapperRef, headerRef);
    useDragContainer(headerRef, scheduleWrapperRef);
    useImperativeHandle(ref, () => ({
      setWidth: (width) => {
        if (wrapperRef.current)
          wrapperRef.current.style.width = `${width}px`;
      },
      setHeight: (height) => {
        if (wrapperRef.current)
          wrapperRef.current.style.height = `${height}px`;
      },
      refetch: () => {
        var _a2;
        (_a2 = appointmentsQueryResult.refetch) == null ? void 0 : _a2.call(appointmentsQueryResult);
      },
      toggleAppointmentDialog: (details, showForm) => {
        toggleModal(void 0, details, showForm);
      },
      openBlockerModal,
      closeAppointmentsModal: () => {
        toggleAppointmentsModal();
      },
      scrollToCurrentDay
    }));
    const isDayView = view === "day";
    const isExtended = isDayView || sortedEmployeesToShow.every((employeesList) => employeesList.length < 4);
    const { height: headerHeight, width: headerWidth } = useElementSize(headerRef);
    const datesColumnWidth = 100 / datesToShow.length;
    const maxStackedAppointments = isDayView && filteredEmployees.length < 3 ? MAX_STACKED_EXTENDED_ITEMS_TO_SHOW : MAX_STACKED_ITEMS_TO_SHOW;
    return /* @__PURE__ */ jsxs(Wrapper, { ref: wrapperRef, children: [
      /* @__PURE__ */ jsxs(InnerWrapper, { children: [
        /* @__PURE__ */ jsx(TimeColumn, { offset: headerHeight, ref: timelineRef, lineWidth: headerWidth }),
        /* @__PURE__ */ jsx(ScheduleWrapper, { ref: scheduleWrapperRef, elevation: 1, isExtended, children: /* @__PURE__ */ jsxs(
          DragAndDropProvider,
          {
            headerRef,
            isExtended,
            scheduleWrapperRef,
            wrapperRef,
            clinicReferenceId: clinicReferenceId ?? "",
            onDropError,
            onDropSuccess,
            children: [
              /* @__PURE__ */ jsx(ScheduleHeaderWrapper, { ref: headerRef, isExtended, children: sortedEmployeesToShow.map((employeesList, index) => {
                const dayColumn = datesToShow[index];
                const defaultDayFormat = format(dayColumn, DATE_FORMAT);
                const columnHeaderTitle = format(dayColumn, "d ccc", { locale });
                const isActive = isToday(dayColumn);
                const minHeaderWidth = getMinHeaderWidth(employeesList.length, isExtended);
                if (!employeesList.length)
                  return null;
                return /* @__PURE__ */ jsxs(
                  ScheduleDayWrapper,
                  {
                    ref: (el) => columnRefs.current[index] = el,
                    ...!isDayView && {
                      minWidth: minHeaderWidth
                    },
                    width: datesColumnWidth,
                    children: [
                      /* @__PURE__ */ jsx(ScheduleDayHeader, { isActive, children: /* @__PURE__ */ jsx(Typography, { variant: "Lato Emphasized 2", children: columnHeaderTitle }) }),
                      /* @__PURE__ */ jsx(ScheduleEmployeesWrapper, { isDayView, children: employeesList.map(({ referenceId, displayName, firstName, lastName, imageUrl }) => {
                        var _a2;
                        const workingHoursByEmployee = (_a2 = workingTimes[defaultDayFormat]) == null ? void 0 : _a2[referenceId];
                        const name = displayName ?? `${firstName} ${lastName}`;
                        const avatarSize = isExtended ? "s" : "m";
                        const workingTimeVariant = isExtended ? "Lato Caption" : "Lato Caption Small";
                        const [startHour, endHour] = getWorkRange(workingHoursByEmployee);
                        const employeeWidth = 100 / employeesList.length;
                        return /* @__PURE__ */ jsxs(ScheduleEmployeeHeader, { isExtended, width: employeeWidth, children: [
                          /* @__PURE__ */ jsxs(AvatarWrapper, { children: [
                            /* @__PURE__ */ jsx(Tooltip, { title: name, placement: "bottom", children: /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Avatar, { size: avatarSize, src: imageUrl ?? void 0, children: getNameInitials(name, 3) }) }) }),
                            isExtended && /* @__PURE__ */ jsx(EmployeeName, { variant: "Lato Emphasized 2", noWrap: true, children: name })
                          ] }),
                          /* @__PURE__ */ jsx(EmployeeWorkingTimes, { variant: workingTimeVariant, isExtended, children: startHour && endHour && `${startHour} - ${endHour}` })
                        ] }, referenceId);
                      }) })
                    ]
                  },
                  dayColumn.toISOString()
                );
              }) }),
              /* @__PURE__ */ jsx(ScheduleContentWrapper, { isExtended, children: sortedEmployeesToShow.map((employeesList, index) => {
                const dayColumn = datesToShow[index];
                const minHeaderWidth = getMinHeaderWidth(employeesList.length, isExtended);
                if (!employeesList.length)
                  return null;
                return /* @__PURE__ */ jsx(
                  ScheduleDayWrapper,
                  {
                    ...!isDayView && {
                      minWidth: minHeaderWidth
                    },
                    width: datesColumnWidth,
                    isContentWrapper: true,
                    children: employeesList.map((employee) => {
                      var _a2, _b;
                      const defaultDayFormat = format(dayColumn, DATE_FORMAT);
                      const employeeAppointments = ((_a2 = appointments == null ? void 0 : appointments[defaultDayFormat]) == null ? void 0 : _a2[employee.referenceId]) ?? [];
                      const employeeNonWorkingTimes = ((_b = nonWorkingTimes == null ? void 0 : nonWorkingTimes[defaultDayFormat]) == null ? void 0 : _b[employee.referenceId]) ?? [];
                      const employeeWidth = 100 / employeesList.length;
                      return /* @__PURE__ */ jsx(
                        EmployeeColumn,
                        {
                          day: dayColumn,
                          employee,
                          isExtended,
                          labels: labels.employeeColumn,
                          appointments: employeeAppointments,
                          nonWorkingTimes: employeeNonWorkingTimes,
                          onClick: handleAppointmentClick,
                          onResize: handleAppointmentResize,
                          maxStackedAppointments,
                          isFetching,
                          isDayView,
                          width: employeeWidth,
                          onPatientClick,
                          isObfuscated
                        },
                        `${employee.referenceId}-${defaultDayFormat}`
                      );
                    })
                  },
                  dayColumn.toISOString()
                );
              }) })
            ]
          }
        ) })
      ] }),
      /* @__PURE__ */ jsx(CustomScrollbar, { containerRef: scheduleWrapperRef.current, offset: (_a = timelineRef.current) == null ? void 0 : _a.scrollWidth })
    ] });
  }
);
const AppointmentSchedule = withAppointmentScheduleProviders(AppointmentScheduleComponent);
export {
  AppointmentSchedule
};
